import React, {useEffect, useState, useCallback} from 'react'
import image1 from '../assets/photos/IMG_7099.jpg'
import image2 from '../assets/photos/IMG_7046.jpg'
import image3 from '../assets/photos/IMG_7047.jpg'
import image4 from '../assets/photos/IMG_7048.jpg'
import image5 from '../assets/photos/IMG_7713.jpg'
import image6 from '../assets/photos/IMG_8117.jpg'
import image7 from '../assets/photos/IMG_7091.jpg'
import image8 from '../assets/photos/IMG_7594.jpg'
import ECB_logo from '../assets/ECB-Logo.jpg'

import styled from 'styled-components'
const Div = styled.div`
display:grid;
position:relative;
grid-template-columns:repeat(6, 1fr);
grid-template-rows:33.3% 33.3% 33.4%;
width:100%;
height:100vh;
max-height:120vw;
overflow:hidden;
background:rgba(0,0,0,.900);
gap:0.5rem;

& div{

   

    & img{
        width:100%;
        height:100%;
        object-fit:cover;
        position:relative;
        filter:grayscale(50%) contrast(75%);
        transition:1s linear;
        transition-delay:0.25s;
    }
}
&::after{
    width:100%;
    height:100%;
    content:"";
    position:absolute;
    top:0;
    left:0;
    background:radial-gradient(transparent,black);
}
`

const black1 = 'rgba(40,40,40)'
const black2 = 'rgba(20,20,20)'

const HeaderTitle = styled.div`
z-index:10;
position:absolute;
width:100%;
top:50%;
left:50%;
transform:translate(-50%,-50%);

& h1{
    color:white;
    font-size:4.5rem;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight:100;
    background:linear-gradient(90deg,${black2},${black1},${black2});
    padding:2rem 0rem;
    box-sizing:border-box;
    position:relative;
    width:100%;
   

    @media only screen and (max-width:600px){
        font-size:3rem;
    }
}
`
const Logo = styled.img`
height:8rem;
width:8rem;
margin-right:1rem;
border-radius:50%;
margin-left:0.5rem;

@media only screen and (max-width:600px){
    height:6rem;
    width:6rem;
    margin-right:0.5rem;
}
`

const Span2Then3 = styled.div`
grid-column:span 2;
@media only screen and (max-width:900px){
    grid-column:span 3
}
`

const DivDesktop = styled.div`
display:block;
grid-column:span 1;
@media only screen and (max-width:900px){
display:none;
}
`

function ImageHeader(){ 

    const [imageLoadCt, setImageLoadCt] = useState(0)

    
    let count = window.innerWidth > 900 ? 9 : 6
    let imageStyle = imageLoadCt >= count ? {
        //loaded
        transform:'rotate(0)',
        opacity:1
    } : {
        //not loaded
        transform:'rotateY(35deg)',
        opacity:0
    }

    let logoStyle = imageLoadCt >= count ? {
        //loaded
        opacity:1,
        transform:'rotateZ(0deg)',
        transition:'1s ease-out',
        transitionDelay:'0.25s',
    } : {
        //not loaded
        transform:'rotateZ(40deg)',
        transition:'1s ease-out',
        transitionDelay:'0.25s',
        opacity:0
    }


    return (
    <header style={{position:'relative'}}>
        <HeaderTitle>
            
                <h1><Logo style={logoStyle} src={ECB_logo}></Logo> <div style={
                    {
                        display:'flex',
                        flexDirection:'column',
                        marginRight:'1rem'
                    }
                    }>ECB
                    {/* <span style={{fontSize:'1.25rem',letterSpacing:'0.3rem',color:'grey'}}>Christian Band</span> */}
                    </div>
                    </h1>
        </HeaderTitle>
    <Div>

      
        <div style={{gridColumn:'span 3'}}>
             <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image2} alt=""/>
        </div>
        <DivDesktop>
            <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image3} alt=""/>
        </DivDesktop>
        <Span2Then3 >
         <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image5} alt=""/>
        </Span2Then3>
        <div style={{gridColumn:'span 2'}}>
             <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)}  src={image6} alt=""/>
        </div>
        <div style={{gridColumn:'span 2'}}>
             <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image5} alt=""/>
        </div>
        <div style={{gridColumn:'span 2'}}>
            <img style={imageStyle}  onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image7} alt=""/>
        </div>
        <Span2Then3>
            <img style={imageStyle}  onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image1} alt=""/>
        </Span2Then3>
        <div style={{gridColumn:'span 3'}}>
         <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image8} alt=""/>
        </div>
        <DivDesktop>
         <img style={imageStyle} onLoad={()=>setImageLoadCt(prevCount=>prevCount+1)} src={image4} alt=""/>
        </DivDesktop>
           
           
            
           
           
           
           
           
            
    </Div>
    </header>
)
}

export default ImageHeader